import { render, staticRenderFns } from "./settings-statuses.vue?vue&type=template&id=5c0ec09b"
import script from "./settings-statuses.vue?vue&type=script&lang=js"
export * from "./settings-statuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports